import React, { useContext, useEffect, useState } from 'react'
import { formatDate, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'
import { useTrainingCategoryContent } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategoryContent'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'

export default function TrainingCategoryContent() {
  const { getAllTrainingCategoryContent, deleteManyTrainingCategoryContent, loading, paginate, updateTrainingCategoryContent } = useTrainingCategoryContent()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { trainingCategoryContents } = useContext(OtherContext)
  //console.log('trainingCategoryContents : ', trainingCategoryContents)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterTrainingCategoryContent = trainingCategoryContents
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllTrainingCategoryContent({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_TRAININGCATEGORYCONTENT')
  }, [])

  const handleChange = (event, value) => setPage(value)

  const handleSwitchChange = (item) => updateTrainingCategoryContent({ ...item, active: !item.active, trainingCategoryContentId: item._id })

  let tableBody = []

  if (!loading && filterTrainingCategoryContent.length > 0) {
    tableBody = filterTrainingCategoryContent.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { image: item.contentThumbnail, type: 'IMAGE' },
        { value: item.trainingCategoryContentCode },
        { value: item.name },
        { value: item.trainingCategory && item.trainingCategory.name },
        // { value: item.metaTags },
        { value: item.description },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-training-category-content/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage Training Category Contents',
    url: ROUTES.ADD_TRAININGCATEGORYCONTENT,
    editUrl: `/edit-training-category-content/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    filename: 'trainingCategoryContents',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'LEARNING',
  }

  return (
    <CustomTableLayout
      tableHeadings={['Image', 'Content Code', 'Name', 'Training category', 'description', 'Created Date', 'Status', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManyTrainingCategoryContent({ trainingCategoryContentId: val }, setSelected)}
    />
  )
}
